import { Component, input, output } from '@angular/core';
import { IconName } from '../icon/icon.component';

@Component({
  selector: 'app-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  /**
   * The label text displayed on the button
   */
  label = input<string>('');

  /**
   * The visual style variant of the button
   */
  variant = input<'primary' | 'secondary' | 'yellow' | 'learn-more' | 'danger'>('primary');

  /**
   * Whether the button is disabled
   */
  disabled = input<boolean>(false);

  /**
   * Optional icon path to display before the label
   */
  icon = input<string | undefined>(undefined);

  /**
   * Optional icon name from app-icon to display before the label
   */
  iconName = input<IconName | undefined>(undefined);

  /**
   * Emits when the button is clicked
   */
  clicked = output<void>();

  onClick(): void {
    if (!this.disabled()) {
      this.clicked.emit();
    }
  }
}
